import * as OpportunitiesActions from "./opportunitiesActions";

export default OpportunitiesActions;
